import Plausible from 'plausible-tracker'

export default {
  install(Vue) {
    const apiHost = 'https://plausible.getnext.to'
    let domain = ''

    let plausibleSegmented = null
    let plausibleGlobal = null
    let currentArtist = ''

    const fixHostName = (url) =>
      url.split('.')[0] === 'de' ? url.split('.').slice(1).join('.') : url

    Vue.mixin({
      beforeCreate() {
        domain = fixHostName(window.location.hostname)
      },
      mounted() {
        const options = this.$options
        if (options.store && options.router) {
          this.$watch('$route', (newRoute) => {
            const item = options.store.state.reward || {}
            const urlAlias = item.urlAlias

            if (!urlAlias) return

            const props = {
              Subscription: !!item.reward,
              'Product Name': item.reward
                ? item.reward.name
                : item.product
                ? item.product.name
                : 'unknown'
            }

            const url = fixHostName(window.location.href)

            if (!plausibleGlobal) {
              plausibleGlobal = new Plausible({
                apiHost,
                domain
              })
            }

            plausibleGlobal.trackPageview(
              { url },
              { props: { ...props, artist: urlAlias } }
            )

            if (!urlAlias || (currentArtist && currentArtist !== urlAlias)) {
              plausibleSegmented = null
              if (!urlAlias) return
            }

            currentArtist = urlAlias

            if (!plausibleSegmented) {
              plausibleSegmented = new Plausible({
                apiHost,
                domain: `${domain}/${currentArtist}`
              })
              plausibleSegmented.trackPageview({ url }, { props })
            }
          })
        }
      }
    })
  }
}
